var styles = {"box":"styles_box__2eyXR","padding":"styles_padding__54EK1","icon":"styles_icon__21hrL","label":"styles_label__2MPQf","info":"styles_info__1gOUZ styles_box__2eyXR","error":"styles_error__HAOVj styles_box__2eyXR","success":"styles_success__1Jkoc styles_box__2eyXR","warning":"styles_warning__1pBaC styles_box__2eyXR"};

export default styles;
//# sourceMappingURL=styles.css.js.map
